import theme from 'config/theme';

export default {
  paper: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '6px 12px',
  },
  selectAllButton: {
    minWidth: 'auto',
    padding: '4px 8px',
    fontSize: '0.875rem',
    textTransform: 'none',
    color: theme.palette.blues.primaryBlue500,
    '&:hover': {
      backgroundColor: theme.palette.grays.gray100,
    },
  },
  resetButton: {
    minWidth: 'auto',
    padding: '4px 8px',
    fontSize: '0.875rem',
    textTransform: 'none',
    color: theme.palette.blues.primaryBlue500,
    '&:hover': {
      backgroundColor: theme.palette.grays.gray100,
    },
  },
  wrapper: (minWidth) => ({
    '& .MuiInputLabel-root[data-shrink="true"]': {
      top: 0,
      color: theme.palette.blues.primaryBlue500,
    },
    '& .MuiAutocomplete-listbox': {
      padding: '4px',
      margin: 0,
    },
    '& .MuiChip-label': {
      cursor: 'pointer',
      color: theme.palette.grays.gray700,
      fontSize: '0.625rem',
    },
    '& .MuiChip-root': {
      backgroundColor: theme.palette.grays.gray200,
      height: '20px',
      minWidth: '30px',
      '& .MuiSvgIcon-root': {
        width: '11px',
        color: theme.palette.grays.gray500,
      },
    },
    '& .MuiAutocomplete-tag': {
      fontSize: '.8rem',
      color: theme.palette.grays.gray500,
    },

    '& .MuiAutocomplete-popper': { minWidth },
    '& .MuiAutocomplete-paper': {
      backgroundColor: '#fff',
    },
    '& .MuiPaper-root': {
      boxShadow: 'none',
      padding: '4px',
    },
    '& .MuiAutocomplete-clearIndicator': {
      svg: { width: '14px' },
      color: theme.palette.blues.blue600,
      '&:hover': {
        background: 'none',
      },
    },
  }),
  button: {
    fontSize: '1rem',
    cursor: 'pointer',
    border: `1px solid ${theme.palette.blues.primaryBlue500}`,
    outline: 'none',
    backgroundColor: '#fff',
    color: `${theme.palette.blues.primaryBlue500}`,
    width: '100%',
    padding: '12px 20px',
    fontWeight: '500',
    borderRadius: '8px',
    '&:hover': {
      color: '#fff',
      backgroundColor: `${theme.palette.blues.primaryBlue500}`,
    },
  },
  autocomplete: {
    width: '100%',
  },
  endAdornmentWrapper: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    right: 0,
    bottom: 0,
    top: 0,
  },

  icon: {
    cursor: 'pointer',
  },
  checkbox: {
    padding: 0,

    color: `${theme.palette.blues.primaryBlue500}`,
    '&.Mui-checked': {
      color: `${theme.palette.blues.primaryBlue500}`,
    },
  },
  filterOptionItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '2px 6px',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    backgroundColor: 'transparent',
    borderRadius: '6px',
    marginBottom: '0',
    fontSize: '0.875rem',
    margin: '5px 0',
    fontWeight: 400,
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: `${theme.palette.grays?.gray100} !important`,
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.palette.grays?.gray100,
      },
    },
    '&.Mui-focusVisible': {
      backgroundColor: theme.palette.grays?.gray100,
    },
  },
  textfield: (variant) => ({
    width: '100%',
    height: '100%',
    fontSize: '0.875rem',
    color: theme.palette.blues.primaryBlue,

    '& .MuiSelect-nativeInput': {
      height: '100%',
    },
    '& .MuiInputBase-input': {
      padding: '10px 12px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border:
        variant === 'filled'
          ? 'none'
          : `1px solid ${theme.palette.grays.gray300}`,
    },

    '& .MuiInputBase-root': {
      paddingRight: '12px!important',

      '&:hover': {
        backgroundColor:
          variant === 'filled'
            ? theme.palette.blues.lightestBlue
            : theme.palette.grays.lightestGray,

        '& .MuiOutlinedInput-notchedOutline': {
          border:
            variant === 'filled'
              ? 'none'
              : `1px solid ${theme.palette.grays.gray300}`,
        },
      },
      '&.Mui-focused': {
        color: theme.palette.grays.gray700,

        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: 1,
          borderColor: theme.palette.grays.gray300,
        },
      },
      '&.Mui-error': {
        '& .MuiOutlinedInput-notchedOutline': {
          boxShadow: theme.customShadows.error,
          borderColor: theme.palette.reds.codingRed200,
        },
        '&.Mui-focused': {
          backgroundColor: theme.palette.grays.lightestGray,
        },
        '&:hover': {
          backgroundColor: theme.palette.grays.lightestGray,
        },
      },
      '&.Mui-disabled': {
        opacity: 0.8,
        pointerEvents: 'none',

        '& .MuiInputBase-input': {
          backgroundColor: 'transparent',
          pointerEvents: 'none',
        },
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
  }),
};
